import { CenterDiv } from "components/CenterDiv"

export const NotFound = () => {
  return (
    <CenterDiv>
      <h1>Página não encontrada</h1>
    </CenterDiv>
  )
}
